/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Select, Checkbox } from 'antd';

import Field from '../../../../UI/field';
import DailyVolume from '../../../../UI/daily-volume';
import { createProviderBotInputs } from '../../../../../helpers/createProviderBotInputs';

import style from '../create-provider-bot-page/create-provider-bot-view.module.scss';
import '../create-provider-bot-page/create-provider-bot-view.scss';
import GreenRedButtonBlock from '../../../../UI/green-red-button-block';

const EditProviderBotView = ({
    createNewBot: {
        source,
        pairName,
        substitutePairName,
        directPairName,
        quantityCuttingEnabled,
        fetchSourceVolume,
        pairSubstituteEnabled,
        quantityLimitForFirstOrder,
        tradingOnTargetExchangeEnabled,
        fetchSourceVolumePercents,
        substitutePairPriceCoefficient,
        quantityLimitStepPercents,
        pricePercentsOfQuantityCuttingArea,
        substitutePairAutoPriceEnabled,
        directPairCourse,
        substitutePairAutoPriceCurrencySource,
        substitutePairAutoPriceCurrencyTarget,
    },
    errors: {
        sourceError,
        pairNameError,
        substitutePairNameError,
        directPairError,
        quantityLimitForFirstOrderError,
        quantityLimitStepPercentsError,
        fetchSourceVolumePercentsError,
        substitutePairPriceCoefficientError,
        pricePercentsOfQuantityCuttingAreaError,
        substitutePairAutoPriceCurrencySourceError,
        substitutePairAutoPriceCurrencyTargetError,
    },
    t,
    times,
    errors,
    createNewBot,
    inputOnchange,
    switchCheckBox,
    timeOnchange,
    selectOnChange,
    refreshDailyPrediction,
    switchSourceVolume,
    cancelCreateBot,
    submitcreateNewBot,
    editProviderBotLoading,
    totalPercentsOfDailyVolume,
    allCoins,
    allSources,
    commonPairs,
    targetPairs,
    pairSubstitutionToggle,
    switchCustomPrice,
    switchDirectBinanceRate,
    switchTradingOnTarget,
    currenciesAll,
}) => {
    const { Option } = Select;

    const isPairSubstituteEnabled = pairSubstituteEnabled ? targetPairs : commonPairs;

    return (
        <form className={style.createNewBot}>
            <div className={style.createNewBot__titleWrapper}>
                <p className={style.createNewBot__title}>
                    {t('aside.liquidityProvider')} / {t('aside.createNewBot')}
                </p>
                <Checkbox
                    className="pairSubstitution"
                    checked={pairSubstituteEnabled}
                    onChange={pairSubstitutionToggle}
                >
                    {t('createBot.pairSubstitution')}
                </Checkbox>
            </div>
            <div className={style.createNewBot__wrapper}>
                <div className={style.createNewBot__wrapper_leftSide}>
                    <div className={style.createNewBot__wrapperInput}>
                        <p className={style.createNewBot__wrapper_title}>{t('createBot.setSourceLiquidity')}</p>
                        <Select
                            showSearch
                            value={source}
                            className="antDSelect"
                            placeholder={t('generals.choose')}
                            onChange={selectOnChange}
                        >
                            {allSources.map(item => (
                                <Option key={item} name="source" value={item}>
                                    {item}
                                </Option>
                            ))}
                        </Select>
                        {sourceError ? (
                            <div
                                className={style.createNewBot__wrapperInput_invalid}
                            >{sourceError}
                            </div>
                        ) : null}
                    </div>
                    <div className={style.createNewBot__wrapperInput}>
                        <p className={style.createNewBot__wrapper_title}>{t('generals.pair')}</p>
                        <Select
                            showSearch
                            value={pairName || undefined}
                            className="antDSelect"
                            placeholder={t('generals.choose')}
                            onChange={selectOnChange}
                        >
                            {isPairSubstituteEnabled.map(items => {
                                const {
                                    left,
                                    right,
                                } = items;
                                return (
                                    <Option
                                        key={`${left}-${right}`}
                                        name="pairName"
                                        value={`${left}-${right}`}
                                    >
                                        {`${left}-${right}`}
                                    </Option>
                                );
                            })}
                        </Select>
                        {pairNameError ? (
                            <div
                                className={style.createNewBot__wrapperInput_invalid}
                            >{pairNameError}
                            </div>
                        ) : null}
                    </div>

                    {pairSubstituteEnabled ? (
                        <div className={style.createNewBot__wrapperInput}>
                            <p className={style.createNewBot__wrapper_title}>{t('createBot.sourcePair')}</p>
                            <Select
                                showSearch
                                value={substitutePairName || undefined}
                                className="antDSelect"
                                placeholder={t('generals.choose')}
                                onChange={selectOnChange}
                            >
                                {allCoins.map(items => {
                                    const {
                                        left,
                                        right,
                                    } = items;
                                    return (
                                        <Option
                                            key={`${left}-${right}`}
                                            name="substitutePairName"
                                            value={`${left}-${right}`}
                                        >
                                            {`${left}-${right}`}
                                        </Option>
                                    );
                                })}
                            </Select>
                            {substitutePairNameError ? (
                                <div className={style.createNewBot__wrapperInput_invalid}>
                                    {substitutePairNameError}
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                    {createProviderBotInputs.map(item => {
                        const {
                            value,
                            label,
                            error,
                            type,
                        } = item;

                        return (
                            <div key={value} className={style.createNewBot__wrapperInput}>
                                <Field
                                    id={value}
                                    type={type}
                                    placeholder={t('generals.typeHere')}
                                    name={value}
                                    value={createNewBot[value]}
                                    error={errors[error]}
                                    onChange={inputOnchange}
                                    inputStyle={style.createNewBot__wrapper_input}
                                    labelText={t(`${label}`)}
                                    labelStyle={style.createNewBot__wrapper_label}
                                />
                            </div>
                        );
                    })}
                    {pairSubstituteEnabled ? (
                        <Fragment>
                            {!substitutePairAutoPriceEnabled ? (
                                <div className={style.createNewBot__wrapperInput}>
                                    <Field
                                        id="substitutePairPriceCoefficient"
                                        type="number"
                                        placeholder={t('generals.typeHere')}
                                        name="substitutePairPriceCoefficient"
                                        value={substitutePairPriceCoefficient}
                                        error={substitutePairPriceCoefficientError}
                                        onChange={inputOnchange}
                                        inputStyle={style.createNewBot__wrapper_input}
                                        labelText={t('createBot.substitutePairPriceCoefficient')}
                                        labelStyle={style.createNewBot__wrapper_label}
                                    />
                                </div>
                            ) : (
                                <Fragment>
                                    {directPairCourse ? (
                                        <div className={style.createNewBot__wrapperInput}>
                                            <p className={style.createNewBot__wrapper_title}>
                                                {t('createBot.directRate')}
                                            </p>
                                            <Select
                                                showSearch
                                                value={directPairName || undefined}
                                                className="antDSelect"
                                                placeholder={t('generals.choose')}
                                                onChange={selectOnChange}
                                            >
                                                {allCoins.map(items => {
                                                    const {
                                                        left,
                                                        right,
                                                    } = items;
                                                    return (
                                                        <Option
                                                            key={`${left}-${right}`}
                                                            name="directPairName"
                                                            value={`${left}-${right}`}
                                                        >
                                                            {`${left}-${right}`}
                                                        </Option>
                                                    );
                                                })}
                                            </Select>
                                            {directPairError ? (
                                                <div
                                                    className={style.createNewBot__wrapperInput_invalid}
                                                >
                                                    {directPairError}
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <Fragment>
                                            <div className={style.createNewBot__wrapperInput}>
                                                <p className={style.createNewBot__wrapper_title}>
                                                    {t('createBot.substitutePairAutoPriceCurrencySource')}
                                                </p>
                                                <Select
                                                    showSearch
                                                    value={substitutePairAutoPriceCurrencySource || undefined}
                                                    className="antDSelect"
                                                    placeholder={t('generals.choose')}
                                                    onChange={selectOnChange}
                                                >
                                                    {currenciesAll.map(items => (
                                                        <Option
                                                            key={items}
                                                            name="substitutePairAutoPriceCurrencySource"
                                                            value={items}
                                                        >
                                                            {items}
                                                        </Option>
                                                    ))}
                                                </Select>
                                                {substitutePairAutoPriceCurrencySourceError ? (
                                                    <div
                                                        className={style.createNewBot__wrapperInput_invalid}
                                                    >
                                                        {substitutePairAutoPriceCurrencySourceError}
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className={style.createNewBot__wrapperInput}>
                                                <p className={style.createNewBot__wrapper_title}>
                                                    {t('createBot.substitutePairAutoPriceCurrencyTarget')}
                                                </p>
                                                <Select
                                                    showSearch
                                                    value={substitutePairAutoPriceCurrencyTarget || undefined}
                                                    className="antDSelect"
                                                    placeholder={t('generals.choose')}
                                                    onChange={selectOnChange}
                                                >
                                                    {currenciesAll.map(items => (
                                                        <Option
                                                            key={items}
                                                            name="substitutePairAutoPriceCurrencyTarget"
                                                            value={items}
                                                        >
                                                            {items}
                                                        </Option>
                                                    ))}
                                                </Select>
                                                {substitutePairAutoPriceCurrencyTargetError ? (
                                                    <div
                                                        className={style.createNewBot__wrapperInput_invalid}
                                                    >
                                                        {substitutePairAutoPriceCurrencyTargetError}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </Fragment>
                                    )}
                                </Fragment>
                            )}
                            <div
                                className={classNames(
                                    style.createNewBot__wrapperInput,
                                    style.createNewBot__wrapperInputLabel,
                                )}
                            >
                                <Checkbox
                                    checked={substitutePairAutoPriceEnabled}
                                    onChange={switchCustomPrice}
                                >
                                    {t('createBot.autoPrice')}
                                </Checkbox>
                            </div>
                            {substitutePairAutoPriceEnabled ? (
                                <div
                                    className={classNames(
                                        style.createNewBot__wrapperInput,
                                        style.createNewBot__wrapperInputLabel,
                                    )}
                                >
                                    <Checkbox
                                        checked={directPairCourse}
                                        onChange={switchDirectBinanceRate}
                                    >
                                        {t('createBot.directBinanceRate')}
                                    </Checkbox>
                                </div>
                            ) : null}
                        </Fragment>
                    ) : null}
                    {quantityCuttingEnabled ? (
                        <Fragment>
                            <div className={style.createNewBot__wrapperInput}>
                                <Field
                                    id="quantityLimitForFirstOrder"
                                    type="number"
                                    placeholder={t('generals.typeHere')}
                                    name="quantityLimitForFirstOrder"
                                    value={quantityLimitForFirstOrder}
                                    error={quantityLimitForFirstOrderError}
                                    onChange={inputOnchange}
                                    inputStyle={style.createNewBot__wrapper_input}
                                    labelText={t('createBot.quantityLimitForFirstOrder')}
                                    labelStyle={style.createNewBot__wrapper_label}
                                />
                            </div>
                            <div className={style.createNewBot__wrapperInput}>
                                <Field
                                    id="quantityLimitStepPercents"
                                    type="number"
                                    placeholder={t('generals.typeHere')}
                                    name="quantityLimitStepPercents"
                                    value={quantityLimitStepPercents}
                                    error={quantityLimitStepPercentsError}
                                    onChange={inputOnchange}
                                    inputStyle={style.createNewBot__wrapper_input}
                                    labelText={t('createBot.quantityLimitStepPercents')}
                                    labelStyle={style.createNewBot__wrapper_label}
                                />
                            </div>
                            <div className={style.createNewBot__wrapperInput}>
                                <Field
                                    id="pricePercentsOfQuantityCuttingArea"
                                    type="number"
                                    placeholder={t('generals.typeHere')}
                                    name="pricePercentsOfQuantityCuttingArea"
                                    value={pricePercentsOfQuantityCuttingArea}
                                    error={pricePercentsOfQuantityCuttingAreaError}
                                    onChange={inputOnchange}
                                    inputStyle={style.createNewBot__wrapper_input}
                                    labelText={t('createBot.pricePercentsOfQuantityCuttingArea')}
                                    labelStyle={style.createNewBot__wrapper_label}
                                />
                            </div>
                        </Fragment>
                    ) : null}
                    <div
                        className={classNames(style.createNewBot__wrapperInput, style.createNewBot__wrapperInputLabel)}
                    >
                        <Checkbox
                            className={style.antCheckboxQuantityCutting}
                            checked={quantityCuttingEnabled}
                            onChange={switchCheckBox}
                        >
                            {t('createBot.quantityCutting')}
                        </Checkbox>
                    </div>
                    {fetchSourceVolume ? (
                        <div className={style.createNewBot__wrapperInput}>
                            <Field
                                id="fetchSourceVolumePercents"
                                type="number"
                                placeholder={t('generals.typeHere')}
                                name="fetchSourceVolumePercents"
                                value={fetchSourceVolumePercents}
                                error={fetchSourceVolumePercentsError}
                                onChange={inputOnchange}
                                inputStyle={style.createNewBot__wrapper_input}
                                labelText={t('createBot.sourceVolumePercents')}
                                labelStyle={style.createNewBot__wrapper_label}
                            />
                        </div>
                    ) : null}
                    <div
                        className={classNames(style.createNewBot__wrapperInput, style.createNewBot__wrapperInputLabel)}
                    >
                        <Checkbox
                            className={style.antCheckboxSourceVolume}
                            checked={fetchSourceVolume}
                            onChange={switchSourceVolume}
                        >
                            {t('createBot.sourceVolume')}
                        </Checkbox>
                    </div>
                    <div
                        className={classNames(style.createNewBot__wrapperInput, style.createNewBot__wrapperInputLabel)}
                    >
                        <Checkbox
                            className={style.tradingOnTargetExchangeEnabled}
                            checked={tradingOnTargetExchangeEnabled}
                            onChange={switchTradingOnTarget}
                        >
                            {t('createBot.tradingOnTargetExchangeEnabled')}
                        </Checkbox>
                    </div>
                </div>
                <div className={style.createNewBot__wrapper_rightSide}>
                    <DailyVolume
                        errors={errors}
                        times={times}
                        onChange={timeOnchange}
                        refreshDailyPrediction={refreshDailyPrediction}
                        totalPercentsOfDailyVolume={totalPercentsOfDailyVolume}
                    />
                </div>
            </div>
            <GreenRedButtonBlock
                greenRedButtonWrapper={style.greenRedButtonWrapper}
                clickGreenBtn={submitcreateNewBot}
                clickRedBtn={cancelCreateBot}
                greenBtnText={t('generals.save')}
                redBtnText={t('generals.cancel')}
                disabled={editProviderBotLoading}
            />
        </form>
    );
};

EditProviderBotView.defaultProps = {
    t: () => {
    },
    inputOnchange: () => {
    },
    timeOnchange: () => {
    },
    selectOnChange: () => {
    },
    refreshDailyPrediction: () => {
    },
    cancelCreateBot: () => {
    },
    submitcreateNewBot: () => {
    },
    switchCheckBox: () => {
    },
    pairSubstitutionToggle: () => {
    },
    switchCustomPrice: () => {
    },
    switchDirectBinanceRate: () => {
    },
    switchSourceVolume: () => {
    },
    switchTradingOnTarget: () => {
    },
    errors: {},
    times: {},
    createNewBot: {},
    allCoins: [],
    allSources: [],
    commonPairs: [],
    targetPairs: [],
    currenciesAll: [],
    totalPercentsOfDailyVolume: 0,
    editProviderBotLoading: false,
};

EditProviderBotView.propTypes = {
    t: PropTypes.func,
    inputOnchange: PropTypes.func,
    timeOnchange: PropTypes.func,
    selectOnChange: PropTypes.func,
    refreshDailyPrediction: PropTypes.func,
    cancelCreateBot: PropTypes.func,
    submitcreateNewBot: PropTypes.func,
    switchCheckBox: PropTypes.func,
    pairSubstitutionToggle: PropTypes.func,
    switchCustomPrice: PropTypes.func,
    switchDirectBinanceRate: PropTypes.func,
    switchSourceVolume: PropTypes.func,
    switchTradingOnTarget: PropTypes.func,
    errors: PropTypes.object,
    times: PropTypes.object,
    allCoins: PropTypes.arrayOf(PropTypes.object),
    allSources: PropTypes.arrayOf(PropTypes.object),
    commonPairs: PropTypes.arrayOf(PropTypes.object),
    targetPairs: PropTypes.arrayOf(PropTypes.object),
    currenciesAll: PropTypes.any,
    createNewBot: PropTypes.object,
    totalPercentsOfDailyVolume: PropTypes.number,
    editProviderBotLoading: PropTypes.bool,
};

export default withTranslation()(EditProviderBotView);
